import { ConsentGroupStore } from '@mfe-4cs/state/ConsentGroupStore';
import { TefComs } from '@mfe-4cs/types/typings';
import { Service } from '@mfe-4cs/util/Service';

export class Tracker {
  private static config?: TefComs.ConfigOptions;
  private service = new Service();

  public static init(config: TefComs.ConfigOptions): void {
    Tracker.config = config;
  }

  private fireEvent(event: string, data: Record<string, unknown> = {}, level: 'info' | 'error' = 'info') {
    this.service.fireEvent<TefComs.EventDetails>({
      name: 'TRACKING',
      level,
      data: {
        event,
        origin: Tracker.config?.lifecycle ?? 'unknown',
        ...data,
      },
    });
  }

  public changePermissions(consentGroups: ConsentGroupStore[]): void {
    let data: Record<string, unknown> = {};
    consentGroups.forEach((group) => {
      const dataMapped = group.consents.reduce<Record<string, unknown>>(
        (acc, { name, granted = false, features }) => {
          const value = features.length
            ? features.reduce<Record<string, unknown>>(
              (acc2, { id, granted: fg = false }) => ({ ...acc2, [id]: fg }),
              {},
            )
            : granted;
          return { ...acc, [name as string]: value };
        },
        {},
      );
      data = {
        ...data,
        ...dataMapped,
      };
      const groupName = group.name;
      // set oc-<group> properties
      if (group.oneclick) {
        // calculate oneclick: true only if all granted
        data[`oc-${groupName}`] = group.areAllConsentsAndFeaturesGranted;
      }
    });

    this.fireEvent('changePermissions', data);
  }

  public clickCollapsable(groupName: string): void {
    const data = { group: groupName };
    this.fireEvent('clickCollapsable', data);
  }

  public comsError(errorMessage: string | undefined): void {
    const data = { error_message: errorMessage };
    this.fireEvent('comsError', data, 'error');
  }
}
